import * as React from 'react';
import { SVGProps } from 'react';
import { withForgeIconProps } from './ForgeIconProps';
interface SVGRProps {
  title?: string;
  titleId?: string;
}

const SvgArrowLeftSmall = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps): JSX.Element => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="fi_c_icon"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M8 15.001L1 8.00098M1 8.00098L8 1.00098M1 8.00098H15"
      stroke={props.color}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

SvgArrowLeftSmall.displayName = 'SvgArrowLeftSmall';
const ArrowLeftSmall = withForgeIconProps(SvgArrowLeftSmall, {
  name: 'ArrowLeft',
  usage: 'Use to indicate the ability to move an item to the left.',
  related: 'move, direction',
  isLabelRequired: false,
  isNeutralInteractive: false,
  size: 'small',
});
export default ArrowLeftSmall;
